@if (showAvatar()) {
    <ap-illustration [name]="avatarBotOrLive()" [hideTitle]="true" width="42px" height="42px"></ap-illustration>
} @else {
    <div [style.min-width.px]="42" [style.min-height.px]="42"></div>
}
<ap-chat-bubble class="ap-flex ap-margin-left-2">
    <span aria-hidden="true" class="ap-display-inline-block loader-icon loader-icon-one"></span>
    <span aria-hidden="true" class="ap-display-inline-block loader-icon loader-icon-two"></span>
    <span aria-hidden="true" class="ap-display-inline-block loader-icon loader-icon-three"></span>
</ap-chat-bubble>
